import { FC } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import { SearchParamKey } from '@app/shared/models/search-param-enum';

export const FocusModeOutlet: FC = () => {
  const [searchParams] = useSearchParams();
  const focusType = searchParams.get(SearchParamKey.FocusType);

  const focusKey = focusType
    ? [
        searchParams.get(SearchParamKey.FocusPaused) === 'true' ? 'paused' : 'active',
        searchParams.get(SearchParamKey.FocusType) ?? '',
        searchParams.get(SearchParamKey.FocusCase) ?? '',
        searchParams.get(SearchParamKey.FocusYear) ?? '',
        searchParams.get(SearchParamKey.FocusMultiple) ?? '',
        searchParams.get(SearchParamKey.FocusInstrument) ?? '',
        searchParams.get(SearchParamKey.FocusHurdle) ?? '',
        searchParams.get(SearchParamKey.FocusHurdleTitle) ?? '',
        searchParams.get(SearchParamKey.FocusSource) ?? '',
      ].join('|')
    : 'unfocused';

  return <Outlet key={focusKey} />;
};
